import { AfterContentInit, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChild, ContentChildren, ElementRef, EventEmitter, Input, OnDestroy, Output, QueryList, TemplateRef, ViewChild, ViewChildren, ViewEncapsulation, inject } from '@angular/core';
import { Header, PrimeTemplate } from 'primeng/api';
import { HisWizardComponent } from './his-wizard.component';
import { FormControl, FormGroup, FormGroupDirective, NgForm, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Button, ButtonDirective } from 'primeng/button';
import { HisWizardPageNextPageEvent } from './his-wizard-interface';
import { HisWizardPageSummaryComponent } from './his-wizard-page-summary.component';
let pageIdx = 0;
@Component( {
    selector: 'his-wizard-page',
    templateUrl: './his-wizard-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./his-wizard-page.component.css'],
    standalone: false
} )
export class HisWizardPageComponent implements AfterContentInit, AfterViewInit, OnDestroy {
    changeDetector = inject( ChangeDetectorRef );

    /**
     * Used to define the header title of the tab.
     * @group Props
     */
    @Input() public title: string | undefined;
    /**
     * Used to define an unique identifier other than the index for better
     * control in dynamic wizard-pages szenarios
     * @group Props
     */
    @Input() public pageKey: string | undefined;

    /**
     * FormGroup of inputs in this page
     */
    @Input() public formGroup: FormGroup | undefined;
    /**
     * Inline style of the tab header.
     * @group Props
     */
    @Input() headerStyle: { [klass: string]: any } | null | undefined;
    /**
     * Inline style of the tab.
     * @group Props
     */
    @Input() tabStyle: { [klass: string]: any } | null | undefined;
    /**
     * Inline style of the tab content.
     * @group Props
     */
    @Input() contentStyle: { [klass: string]: any } | null | undefined;
    /**
     * Style class of the tab.
     * @group Props
     */
    @Input() tabStyleClass: string | undefined;
    /**
     * Style class of the tab header.
     * @group Props
     */
    @Input() headerStyleClass: string | undefined;
    /**
     * Style class of the tab content.
     * @group Props
     */
    @Input() contentStyleClass: string | undefined;
    /**
     * Whether the tab is disabled.
     * @group Props
     */
    @Input() disabled: boolean | undefined = false;
    /**
     * Whether the tab is visible.
     * @group Props
     */
    @Input() visible: boolean | undefined = true;
    /**
     * Whether a lazy loaded panel should avoid getting loaded again on reselection.
     * @group Props
     */
    @Input() cache: boolean = true;
    /**
     * Transition options of the animation.
     * @group Props
     */
    @Input() transitionOptions = '0ms';
    /**
     * Position of the icon.
     * @group Props
     */
    @Input() iconPos: 'end' | 'start' = 'start';
    /**
     * Event triggered by changing the choice.
     * @param {boolean} value - Boolean value indicates that the option is changed.
     * @group Emits
     */
    @Output() selectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ContentChildren( Header ) headerFacet!: QueryList<Header>;

    @ContentChildren( PrimeTemplate ) templates!: QueryList<PrimeTemplate>;

    @ContentChildren( FormGroup ) contentForms: QueryList<FormGroup> | undefined;

    private _selected = false;

    /**
     * The value that returns the selection.
     * @group Props
     */
    @Input() get selected(): boolean {
        return this._selected;
    }

    set selected( val: boolean ) {
        this._selected = val;

        if ( !this.loaded ) {
            if ( this._selected && this.cache ) {
                this.loaded = true;
            }

            this.changeDetector.detectChanges();
        }
    }

    get iconClass() {
        if ( this.iconPos === 'end' ) {
            return 'p-accordion-toggle-icon-end';
        } else {
            return 'p-accordion-toggle-icon';
        }
    }

    contentTemplate: TemplateRef<any> | undefined;

    headerTemplate: TemplateRef<any> | undefined;

    iconTemplate: TemplateRef<any> | undefined;

    id = `p-accordiontab-${pageIdx++}`;

    loaded = false;

    wizard: HisWizardComponent;
    wizardPageSummarys: HisWizardComponent;
    @Input() public index: number;

    @Input() public noButtons: boolean = false;


    @Output() contentChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

    @Output() statusChange: EventEmitter<any> = new EventEmitter<any>();

    @Output() nextPageEvent: EventEmitter<HisWizardPageNextPageEvent> = new EventEmitter<HisWizardPageNextPageEvent>();

    @Output() pageSelected: EventEmitter<number> = new EventEmitter<number>();

    //@ContentChildren( FormGroup, { descendants: true } ) formGroupChildren: QueryList<FormGroup> | undefined;

    //@ContentChildren( FormGroup, { descendants: true } ) reactiveFormChild: QueryList<FormGroup> | undefined;

    @ContentChild( FormGroupDirective, { static: true } ) reactiveFormChild: FormGroupDirective | undefined;

    @ContentChild( NgForm, { static: true } ) templateFormChild: NgForm;

    @ViewChild( 'nextButton' ) nextButton: ElementRef;

    @ViewChild( 'submitButton' ) submitButton: ElementRef;


    @ContentChild( HisWizardPageSummaryComponent ) pageSummary!: HisWizardPageSummaryComponent;

    localFormGroup: FormGroup | undefined;

    formValueChangesSubscription: Subscription | null = null;


    constructor() {
        const wizard = inject( HisWizardComponent );

        this.wizard = wizard as HisWizardComponent;
    }

    ngAfterViewInit(): void {
        //throw new Error( 'Method not implemented.' );

        //console.log( 'formGroupChildren', this.formGroupChildren );
        // this.reactiveFormChildSubscription = ( this.reactiveFormChild as unknown as QueryList<FormGroup> ).changes.subscribe( ( _ ) => {
        //     console.log( 'reactiveFormChild', this.reactiveFormChild );
        //     this.localPagereactiveFormChild = this.reactiveFormChild;
        // } );

        console.log( 'templateFormChild', this.templateFormChild );
        console.log( 'reactiveFormChild', this.reactiveFormChild );

        if ( !this.reactiveFormChild && !this.templateFormChild && this.nextButton ) {
            console.log( 'enable next button', this.nextButton );
            this.nextButton.nativeElement.disabled = false;
            this.statusChange.emit( { index: this.index, status: 'VALID' } );
        }

        if ( !this.reactiveFormChild && !this.templateFormChild && this.submitButton ) {
            console.log( 'enable submit button', this.submitButton );
            this.submitButton.nativeElement.disabled = false;
            this.statusChange.emit( { index: this.index, status: 'VALID' } );
        }

        if ( this.reactiveFormChild ) {
            this.subscribeValueChanges( this.reactiveFormChild.form );
        } else if ( this.templateFormChild ) {
            console.log( 'template subscribe value changes', this.templateFormChild );
            this.subscribeValueChanges( this.templateFormChild.form );
            // this.formValueChangesSubscription = this.templateFormChild.controls.input.subscribe( () => {
            //     console.log( 'input valueChange', this.templateFormChild);
            // } );
            // Object.keys( this.templateFormChild.form.controls ).forEach(key => {
            //     console.log( 'add onChange to template formControl', key, this.templateFormChild.form.get( key ) );
            //     this.templateFormChild.form.get( key ).valueChanges.subscribe( () => {
            //         console.log( 'input valueChange', this.templateFormChild.form.get( key ) );
            //     } );
            // });
        }
        //console.log( 'localFormGroup', this.localFormGroup );

        //console.log( 'tempForm', this.tempForm );
        // this.contentChange.subscribe( resp => {
        //     console.log( 'wizard page reactiveFormChild change', resp );
        // } );
    }
    /**
     * activates next or submit button, if containing form is valid
     * @param formGroup
     */
    subscribeValueChanges( formGroup: FormGroup ) {
        if ( !formGroup ) return;

        this.formValueChangesSubscription = formGroup.valueChanges.subscribe( () => {
            // Buttons wie bisher aktivieren/deaktivieren …
            if ( formGroup.status === 'VALID' && this.nextButton ) this.nextButton.nativeElement.disabled = false;
            if ( formGroup.status === 'VALID' && this.submitButton ) this.submitButton.nativeElement.disabled = false;
            if ( formGroup.status === 'INVALID' && this.nextButton ) this.nextButton.nativeElement.disabled = true;
            if ( formGroup.status === 'INVALID' && this.submitButton ) this.submitButton.nativeElement.disabled = true;

            // Wizard über Status informieren
            if ( formGroup.status === 'VALID' ) this.statusChange.emit( { index: this.index, status: 'VALID' } );
            if ( formGroup.status === 'INVALID' ) this.statusChange.emit( { index: this.index, status: 'INVALID' } );

            this.contentChange.emit( formGroup );
        } );

        // Initialzustand einmalig senden (falls Formular schon valid ist)
        const initStatus = formGroup.status;
        this.statusChange.emit( { index: this.index, status: initStatus } );
    }

    ngAfterContentInit() {
        this.templates.forEach( ( item ) => {
            switch ( item.getType() ) {
                case 'content':
                    this.contentTemplate = item.template;
                    break;

                case 'header':
                    this.headerTemplate = item.template;
                    break;

                case 'icon':
                    this.iconTemplate = item.template;
                    break;

                default:
                    this.contentTemplate = item.template;
                    break;
            }
        } );
        //console.log( 'formGroupChildren', this.formGroupChildren, this.reactiveFormChild.length );
        //console.log( 'reactiveFormChild', this.reactiveFormChild );
    }

    // isContainingFormValid() {
    //     if ( ! this.reactiveFormChild ) return false;
    //     return this.reactiveFormChild.form.status === 'VALID' ? true : false;
    // }

    prevPage() {
        this.wizard.selectPrevPage();
    }

    nextPage() {
        console.log( 'clicked next...' );
        //let index = this.findTabIndex();
        // this.wizard.selectPageIndex( index++ );
        //this.nextPageEvent.emit();

        this.wizard.selectNextPage();
    }

    showPageKey( pageKey: string ) {
        console.log( 'wizard-page showPageKey', pageKey );
        this.wizard.enablePageKey( pageKey );
        this.statusChange.emit( { index: this.index, status: 'SHOW_PAGE_KEY', pageKey: pageKey } );
    }

    onWizardSubmit() {
        console.log( 'onPageSubmit reactiveFormChild', this.reactiveFormChild );
        this.statusChange.emit( { index: this.index, status: 'WIZARD_SUBMIT' } );

    }

    hasNextIndex() {
        return this.wizard.isIndexValid( this.findTabIndex() + 1 );
    }

    hasPrevIndex() {
        return this.wizard.isIndexValid( this.findTabIndex() - 1 );
    }

    toggle( event: MouseEvent | KeyboardEvent ) {
        if ( this.disabled ) {
            return;
        }


        let index = this.findTabIndex();

        if ( index > this.wizard.activeIndex ) {
            return;
        }

        if ( this.selected ) {
            this.selected = false;
            this.wizard.tabClose.emit( { originalEvent: event, index: index } );
        } else {
            // if ( !this.wizard.multiple ) {
            for ( let i = 0; i < this.wizard.pages.length; i++ ) {
                if ( this.wizard.pages[i].selected ) {
                    this.wizard.pages[i].selected = false;
                    this.wizard.pages[i].selectedChange.emit( false );
                    this.wizard.pages[i].changeDetector.markForCheck();
                }
            }
            //}

            this.selected = true;
            this.loaded = true;
            this.wizard.tabOpen.emit( { originalEvent: event, index } );
        }

        this.selectedChange.emit( this.selected );
        this.wizard.selectPageIndex( index );
        this.changeDetector.markForCheck();

        // Index der ausgewählten Seite an his-wizard Komponente weiterreichen
        this.pageSelected.emit( index );

        event.preventDefault();
    }

    findTabIndex() {
        let index = -1;
        for ( let i = 0; i < this.wizard.pages.length; i++ ) {
            if ( this.wizard.pages[i] == this ) {
                index = i;
                break;
            }
        }
        return index;
    }

    get hasHeaderFacet(): boolean {
        return ( this.headerFacet as QueryList<Header> ) && ( this.headerFacet as QueryList<Header> ).length > 0;
    }

    onKeydown( event: KeyboardEvent ) {
        if ( event.which === 32 || event.which === 13 ) {
            this.toggle( event );
            event.preventDefault();
        }
    }
    onChanges() {
        this.changeDetector.detectChanges();
    }

    ngOnDestroy() {
        if ( this.formValueChangesSubscription ) {
            this.formValueChangesSubscription.unsubscribe();
        }

        this.wizard.pages.splice( this.findTabIndex(), 1 );

    }
    onAnimationDone(event: any) {
        // Fix for height:0px stuck after panel toggle
        // When animation completes to 'visible' state but height is still 0px, clear it
        if (event.toState === 'visible' && this.selected) {
            const element = event.element as HTMLElement;
            // Check if height is stuck at 0px
            if (element && (element.style.height === '0px' || element.style.height === '0')) {
                // Clear the height to let it expand naturally
                element.style.height = '';
                // Trigger change detection to ensure content renders
                this.changeDetector.detectChanges();
            }
        }
    }
}
